import { TailSpin } from "react-loader-spinner";
import "./style.scss";

const LoadingSpinner = ({
  className,
  icon,
  title,
  textSize,
  textColor,
  loaderSize,
  loaderColor,
  miniLoader,
}) => {
  return miniLoader ? (
    <div className="mini-loader">
      {icon && <span>{icon}&nbsp;</span>}
      {title && (
        <div
          className="downloading-text"
          style={{
            fontSize: textSize || "20px",
            color: textColor || "#29badb",
          }}
        >
          {title}
        </div>
      )}
      <TailSpin
        className="tailspin"
        height={loaderSize || "50"}
        width={loaderSize || "50"}
        color={loaderColor || "#29badb"}
        text-align="center"
        top="0"
        bottom="0"
        ariaLabel="tail-spin-loading"
        wrapperStyle={{}}
        wrapperClass="tailspin"
        visible={true}
        radius="2"
      />
    </div>
  ) : (
    <div className={`loader-wrapper-div ${className}`}>
      <TailSpin
        className="tailspin"
        height={loaderSize || "50"}
        width={loaderSize || "50"}
        color={loaderColor || "#29badb"}
        text-align="center"
        top="0"
        bottom="0"
        ariaLabel="tail-spin-loading"
        wrapperStyle={{}}
        wrapperClass="tailspin"
        visible={true}
      />
      {title && (
        <div
          className="downloading-text"
          style={{
            fontSize: textSize || "20px",
            color: textColor || "#29badb",
            marginTop: "20px",
          }}
        >
          {title}
        </div>
      )}
    </div>
  );
};

export default LoadingSpinner;
